export default {
  All: 'all',
  Complete: 'complete',
  Incomplete: 'incomplete',
}
